import { Search } from 'lucide-react'
import { cn } from '@/utils'

type TraySearchInputProps = {
  value: string
  onChange: (value: string) => void
  placeholder: string
  /** Accessible name — defaults to `placeholder`, which is otherwise the only visible label. */
  ariaLabel?: string
  className?: string
}

/** Search-icon text field used inside a tray's Filters section (e.g. "Search by filename"). */
export function TraySearchInput({
  value,
  onChange,
  placeholder,
  ariaLabel,
  className,
}: TraySearchInputProps) {
  return (
    <div
      className={cn(
        'flex h-9 w-full min-w-0 items-center gap-1 overflow-hidden rounded-md border border-input bg-background px-3 py-1 shadow-xs',
        className
      )}
    >
      <Search className="size-4 shrink-0 text-muted-foreground" aria-hidden="true" />
      <input
        type="text"
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="h-full min-w-0 flex-1 bg-transparent text-sm text-foreground outline-none placeholder:text-muted-foreground"
      />
    </div>
  )
}
